module.exports = __webpack_public_path__ + "img/여성패딩.fa4a7231.png";